import { Component, OnInit, Input } from '@angular/core';
import { MedicalConditionModel } from '../../../models/consultation-history/medical-condition.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { ConsultationHistoryService } from '../consultation-history.service';
import { MedicalConditionHistoryPopupComponent } from './medical-condition-popup.component';

@Component({
    selector: 'ch-medical-condition',
    templateUrl: 'medical-condition.component.html',
    providers: [ConsultationHistoryService]
})

export class MedicalConditionComponent implements OnInit {
    @Input() history = false;
    @Input() patientId: string;
    @Input() consultationHistoryId: string;
    @Input() histories = [];
    @Input() medicalConditions: MedicalConditionModel[];
    @Input() isFromConsultationHistory: boolean;
    @Input() height: number;
    public klass = 'consultationhistory';
    constructor(public dialog: DialogService, public consultationHistoryService: ConsultationHistoryService) { }

    ngOnInit() {
        this.height = this.height ? (this.height > 600 ? this.height - 172 : this.height - 185) : null;
    }

    openMedicalCondition(medicalCondition: MedicalConditionModel) {
        const height = window.screen.height - (window.screen.height * 30 / 100);
        const data = {
            patientId: this.patientId,
            consultationHistoryId: this.consultationHistoryId,
            isFromConsultationHistory: this.isFromConsultationHistory,
            height: height
        };
        const arrayId = [];
        arrayId.push(data.consultationHistoryId);
        this.dialog.openComponentDialog(MedicalConditionHistoryPopupComponent, data,
            { width: '80%', height: height + 'px' }).subscribe(isSuccess => {
                if (isSuccess) {
                    this.consultationHistoryService.getMedicalCondition(arrayId).subscribe(callback => {
                        if (callback) {
                            const dataCallback = callback.json();
                            this.medicalConditions = dataCallback;
                        }
                    });
                }
            });
    }
}





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/medical-condition/medical-condition.component.ts